/**
 * @desc 根据供应商id和sku查询sku报价信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierQuotationFacadeImpl.getQuotationBySupplierIdNameAndSku.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/getQuotationBySupplierIdNameAndSku`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
